/**
 * Decodes a JSON string to a JavaScript value.
 * Returns null for empty strings instead of throwing an error.
 *
 * @param data - JSON string to parse
 * @returns Parsed JavaScript value or null if data is empty
 *
 * @example
 * ```ts
 * import { JSONDecode } from "@pdfking/tfunc"
 *
 * const obj = JSONDecode('{"name":"John","age":30}')
 * console.log(obj.name) // "John"
 *
 * const empty = JSONDecode("")
 * console.log(empty) // null
 * ```
 */
import { RecordQ } from "@pdfking/structs"

const defaults = { bigint: false }

const reviver = (_: string, value: unknown) =>
  RecordQ(value) && "__bigint__" in value
    ? BigInt((value as { __bigint__: string }).__bigint__)
    : value

export const JSONDecode = (data: string, options: typeof defaults = defaults) =>
  data ? JSON.parse(data, options.bigint ? reviver : undefined) : null
